
































































import { namespace } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { Validator, FieldError } from 'vee-validate';

import { EPaymentMethodTypes } from '@/helpers/enums';
import { IUpsell } from '@/interfaces/Upsell';

import Checkbox from '@/shared/components/Inputs/Checkbox.vue';
import Button from '@/shared/components/Button/Button.vue';

import EssencialInfo from '../Form/EssencialInfo.vue';

import Customer from '@/classes/Customer';

const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Checkbox,
    Button,
    EssencialInfo,
  }
})
export default class KoinOptinStep extends Vue {
  private form: any = {
    acceptTerms: false,
    essencialInfo: {
      name: '',
      birthday: '',
    }
  };

  public $refs!: {
    essentialsInfo: EssencialInfo;
  };

  private loading: boolean = false;
  private errorCustomer: boolean = false;

  private validator = new Validator();

  @CheckoutModule.State
  private upsell: IUpsell;

  @CustomerModule.Getter('getCustomerLogged')
  private customerLogged!: Customer;

  @CheckoutModule.Mutation
  private readonly setKoinOptinChecked!: Function;

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get disableNextButton() {
    return !this.form.acceptTerms;
  }

  private emitGoBack() {
    this.form.acceptTerms = false;
    this.setKoinOptinChecked(this.form.acceptTerms);
    this.$emit('goBack');
  }

  private async prepareCheckout() {
    try {
      this.loading = true;
      await this.$refs.essentialsInfo.validateCustomer();

      if(!this.errorCustomer){
        let payload = {
          payment_method: EPaymentMethodTypes.bankSlip,
          is_payment_in_installments: this.form.acceptTerms,
          is_terms_accepted: this.form.acceptTerms
        };

        this.$emit('prepareBankSlipInstallments', payload);
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  private async errorUpdateCustomer(status: boolean) {
    this.errorCustomer = status;
  }

  @Watch('form.acceptTerms', { immediate: true })
  changeAcceptTerms(value: boolean) {
    this.setKoinOptinChecked(value);
  }

  mounted() {
    this.errorCustomer = false;
  }

  private destroyed() {
    this.validator.reset();
  }
}
